<template>
  <div class="d-flex flex-column mt-4 mb-2 p-3 bg-gray-200">
    <div v-if="pillFilters" class="mb-4">
      <b-button
        v-for="(filter, i) in pillFilters"
        :key="i"
        pill
        variant="secondary"
        class="mr-1 border-primary text-primary"
        @click.stop="clearFilter(filter)"
      >
        <span>&times;</span>
        {{ filter.pill }}
      </b-button>
    </div>
    <div class="row">
      <div
        v-for="filter in currentFilters"
        :key="filter.field"
        :class="calculateWidth(filter)"
      >
        <b-form-group :label="filter.label">
          <template v-if="isString(filter.type)">
            <b-form-input
              v-model="filter.model"
              :name="filter.field"
              type="text"
            />
          </template>
          <template v-else-if="isNumber(filter.type)">
            <b-form-input
              v-model="filter.model"
              :name="filter.field"
              type="number"
            />
          </template>
          <template v-else-if="isDate(filter.type)">
            <date-range-picker
              ref="picker"
              v-model="filter.model"
              :time-picker="true"
              :locale-data="dateTimePicker.locale"
              :ranges="dateTimePicker.range"
            />
          </template>
          <template v-else-if="isSelect(filter.type)">
            <b-form-input
              v-model="filter.model"
              :name="filter.field"
              type="text"
            />
          </template>
          <template v-else-if="isBoolean(filter.type)">
            <b-checkbox v-model="filter.model" sync switch size="lg" />
          </template>
        </b-form-group>
      </div>
    </div>
    <div class="d-flex justify-content-end align-items-center mt-1">
      <b-button
        variant="secondary mr-2 text-primary"
        class="black border-primary"
        @click.stop="clearFilters"
      >
        {{ $t("actions.clear") }}
      </b-button>
      <b-button
        variant="success"
        class="text-white"
        @click.stop="setCurrentFilters"
      >
        {{ $t("actions.filter") }}
      </b-button>
    </div>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import { dateTimePicker } from '@/config/list'
import moment from 'moment'

export default {
  components: {
    DateRangePicker
  },
  props: {
    filters: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    dateTimePicker,
    currentFilters: {},
    pillFilters: null,
    empty: {}
  }),
  created() {
    this.currentFilters = this.filters
    this.setPillFilters()
  },
  methods: {
    isNumber(type) {
      return type === 'number'
    },
    isString(type) {
      return type === 'string'
    },
    isDate(type) {
      return type === 'date'
    },
    isSelect(type) {
      return type === 'select'
    },
    isObject(item) {
      return typeof item === 'object' && item !== null
    },
    isBoolean(type) {
      return type === 'boolean'
    },
    calculateWidth(filter) {
      return `col-${filter.filterWidth ?? '12'}`
    },
    setDateObjectOrNull(model) {
      if (this.isObject(model)) {
        return { model: { startDate: null, endDate: null } }
      } else if (typeof model === 'boolean') {
        return { model: false }
      } else {
        return { model: null }
      }
    },
    resetModel(item) {
      return item ? { ...item, ...this.setDateObjectOrNull(item.model) } : null
    },
    clearFilters() {
      this.currentFilters = this.currentFilters.map(item =>
        this.resetModel(item)
      )
      this.setCurrentFilters()
    },
    clearFilter(filter) {
      this.currentFilters = this.currentFilters.map(item => {
        return item.field === filter.field ? this.resetModel(item) : item
      })
      this.setCurrentFilters()
    },
    setCurrentFilters() {
      this.formatFiltersDates()
      this.$emit('updateFilters', this.currentFilters)
      this.setPillFilters()
    },
    setPillFilters() {
      this.pillFilters = JSON.parse(JSON.stringify(this.currentFilters))
        .filter(
          p =>
            (this.isObject(p.model) && p.model.startDate) ||
            (!this.isObject(p.model) && p.model)
        )
        .map(i => {
          const value = this.isObject(i.model)
            ? this.formatLabelFilterDate(i)
            : i.model
          i.pill = `${i.label}: ${value}`
          return i
        })
    },
    formatLabelFilterDate(item) {
      return `${this.formatFilterDate(
        item.model.startDate
      )} - ${this.formatFilterDate(item.model.endDate)}`
    },
    formatFilterDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    formatFiltersDates() {
      this.currentFilters.map(f => {
        if (f.type === 'date' && f.model && f.model.startDate) {
          f.model.startDate = this.formatFiltersDate(f.model.startDate)
          f.model.endDate = this.formatFiltersDate(f.model.endDate)
        }
      })
    },
    formatFiltersDate(date) {
      return moment(date)
        .utc(true)
        .toISOString()
        .slice(0, 19)
        .replace('T', ' ')
    }
  }
}
</script>
